import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ILoginRequest } from '../../../core/models';
import { UserService } from '../../../core/services/user.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent  {

  title = 'SnapPayLoginUI';
  loginemail: any = "";
  loginpwd: any = "";
  loginRequest: ILoginRequest = {
    username: '',
    password: ''
  }
  constructor(private userService: UserService, private router: Router) {

  }
  async login() {
    this.loginRequest.username = this.loginemail;
    this.loginRequest.password = this.loginpwd;
    const loginResponse = await this.userService.login(this.loginRequest);

    if (!loginResponse) { alert("Error occured"); return; }
    if (loginResponse.isValid) {
      if (!loginResponse.token) {
        alert("Error occured"); return;
      }
      this.userService.saveToken(loginResponse.token);
      //setTimeout(function () { /* snip */ }, 1000);
      const userDetails = await this.userService.getUserDetails();

      this.userService.saveUserObject(userDetails);
      this.router.navigate(['sample-request-admin/home']);
    } else {
      alert(loginResponse.error);
      return;
    }
  }
  async forgetpassword() {
    if (this.loginemail) {
      if (confirm('Are you sure you want to forget password?')) {
        const loginBody = { userName: this.loginemail };
        await (await this.userService.ForgotPassword(loginBody)).subscribe((r: any) => {
          if (r.errorMessage == "Success") {
            alert(r.errorMessage);
          } else {
            alert(r.errorMessage);
          }
        });
      }
    } else {
      alert("please enter the username");
    }
  }
}
